/**
 * AMAÇ: Surekly marka logosu — istiflenmiş kanıt kartları + yükselen seri oku,
 * lacivert bir halkanın içinde (Safir paleti renkleriyle)
 */
export default function Logo({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* halka */}
      <circle cx="24" cy="24" r="20.6" stroke="#183882" strokeWidth="2.6" />

      {/* istiflenmiş kanıt kartları */}
      <rect x="9.5" y="20" width="15" height="12" rx="2.1" fill="#ACC3F2" transform="rotate(-14 17 26)" />
      <rect x="15" y="17.5" width="16" height="13" rx="2.1" fill="#3A66C7" transform="rotate(2 23 24)" />
      <rect x="21" y="15.5" width="16" height="13" rx="2.1" fill="#7F72D9" transform="rotate(16 29 22)" />

      {/* yükselen seri oku — beyaz hale + gradyan çizgi */}
      <g strokeLinecap="round" strokeLinejoin="round" fill="none">
        <polyline points="6 34 18 22 26 30 42 12" stroke="white" strokeWidth="5.4" />
        <polyline points="30 12 42 12 42 24" stroke="white" strokeWidth="5.4" />
        <polyline points="6 34 18 22 26 30 42 12" stroke="url(#zy-arrow-grad)" strokeWidth="3" />
        <polyline points="30 12 42 12 42 24" stroke="url(#zy-arrow-grad)" strokeWidth="3" />
      </g>

      <defs>
        <linearGradient id="zy-arrow-grad" x1="6" y1="34" x2="42" y2="12" gradientUnits="userSpaceOnUse">
          <stop stopColor="#183882" />
          <stop offset="1" stopColor="#7F72D9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
